import {
  OntologyContextType,
  OntologyField,
  OntologyRolodexEntryType,
  useOntology,
} from 'features/dynamicOntology'
import { Dispatch, FC, ReactNode, SetStateAction, useMemo } from 'react'
import styled from 'styled-components'

import { OneStepSelect, OneStepSelectOption } from './components/OneStepSelect'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  gap: 1rem;
`

type FieldSelectProps = {
  label?: ReactNode
  fields?: OntologyContextType['fields']
  selectedType: OntologyRolodexEntryType
  selectedField: OntologyField
  setSelectedField: Dispatch<SetStateAction<OntologyField>>
  placeholder?: string
  width?: string
}

export const DrilldownFieldSelect: FC<FieldSelectProps> = ({
  label,
  selectedType,
  selectedField,
  setSelectedField,
  fields: propFields,
  placeholder,
  width = '240px',
}) => {
  const { fields: hookFields } = useOntology()
  const fields = useMemo(
    () => propFields ?? hookFields,
    [hookFields, propFields]
  )

  const fieldOptions = useMemo<ReadonlyArray<OneStepSelectOption>>(
    () =>
      Object.entries(fields)
        .filter(([fieldKey]) => fieldKey.startsWith(`${selectedType}.`))
        .map(([fieldKey, fieldDef]) => ({
          value: fieldKey,
          label: fieldDef.name,
        }))
        .toSorted((a, b) => a.label.localeCompare(b.label)),
    [fields, selectedType]
  )

  return (
    <Container>
      {label ?? <></>}
      <OneStepSelect
        options={fieldOptions}
        selectedValue={selectedField}
        setSelectedValue={setSelectedField}
        placeholder={placeholder}
        width={width}
      />
    </Container>
  )
}
